/*eslint-disable prefer-const */
/*eslint-disable array-callback-return */
import { getCoverageTypeOrderNumber } from './common';

export const CoverageDetailedSummary = (
  memberCoverages,
  benifitAccumulators,
) => {
  const { BenefitAccumulators, PlanDetails } = benifitAccumulators;
  const detailedCoverageSummary = [];
  memberCoverages.map((coverageData) => {
    let eachProductData,
      benitPlanInfoInNetwork = [],
      benitPlanOutOfNetwork = [],
      benitPlanPenalty = [],
      spendingAmounts = [];
    eachProductData = {
      ...coverageData,
      order: getCoverageTypeOrderNumber(coverageData.Product),
    };
    benitPlanInfoInNetwork =
      PlanDetails.length > 0
        ? PlanDetails.filter((planData) => {
            //console.log('benitPlanInfoInNetwork, coverageData.Product === planData.Product',
            //coverageData.Product, planData.Product,
            //coverageData.Product === planData.Product,
            //coverageData.BenefitPlan, planData.BenefitPlanName,
            //coverageData.BenefitPlan === planData.BenefitPlanName
            //);

            if (
              coverageData.Product === planData.Product &&
              coverageData.BenefitPlan === planData.BenefitPlanName &&
              (planData.BenefitScheduleType === 'Default Benefit Schedule' ||
                planData.BenefitScheduleType === 'IN-Network' ||
                planData.BenefitScheduleType === 'In-Network') //Adding Additional Check this should be handled in API
            ) {
              return planData;
            }
          })
        : [];
    benitPlanOutOfNetwork =
      PlanDetails.length > 0
        ? PlanDetails.filter((planData) => {
            if (
              coverageData.Product === planData.Product &&
              coverageData.BenefitPlan === planData.BenefitPlanName &&
              planData.BenefitScheduleType === 'Out-Of-Area'
            ) {
              return planData;
            }
          })
        : [];
    benitPlanPenalty =
      PlanDetails.length > 0
        ? PlanDetails.filter((planData) => {
            if (
              coverageData.Product === planData.Product &&
              coverageData.BenefitPlan === planData.BenefitPlanName &&
              planData.BenefitScheduleType === 'Penalty'
            ) {
              return planData;
            }
          })
        : [];
    spendingAmounts =
      BenefitAccumulators.length > 0
        ? BenefitAccumulators?.filter((eachAppliedAmount) => {
            if (eachAppliedAmount.Product === coverageData.Product) {
              return eachAppliedAmount;
            }
          })
        : [];
    detailedCoverageSummary.push({
      ...eachProductData,
      InNetworkPlanDetails: {
        ...(benitPlanInfoInNetwork.length > 0
          ? benitPlanInfoInNetwork[0]?.Benefits || []
          : []),
        SpendingAmounts: {
          ...(spendingAmounts.length > 0
            ? spendingAmounts[0]?.Accumulators || []
            : []),
        },
      },
      OutOfNetworkPlanDetails: {
        ...(benitPlanOutOfNetwork.length > 0
          ? benitPlanOutOfNetwork[0]?.Benefits || []
          : []),
        SpendingAmounts: {
          ...(spendingAmounts.length > 0
            ? spendingAmounts[0]?.Accumulators || []
            : []),
        },
      },
      PenaltyPlanDetails: {
        ...(benitPlanPenalty.length > 0
          ? benitPlanPenalty[0]?.Benefits || []
          : []),
        SpendingAmounts: {
          ...(spendingAmounts.length > 0
            ? spendingAmounts[0]?.Accumulators || []
            : []),
        },
      },
    });
  });
  detailedCoverageSummary.sort((a, b) => a.order - b.order);
  return detailedCoverageSummary;
};

export const getFamilyList = (
  employeeInfo,
  dependentsInfo = [],
  loggedInMemberType,
  loggedInUserOID,
) => {
  const options = [];
  if (employeeInfo.LoggedInMemberType === 'Employee') {
    if (employeeInfo.Family) {
      options.push({
        label: `Family (${dependentsInfo.length + 1})`,
        value: 'Family',
        memberType: 'Employee',
      });
    }
    options.push({
      label: `${employeeInfo.FirstName} (Employee)`,
      value: `${employeeInfo.OID}`,
      memberType: 'Employee',
    });
    dependentsInfo.map((dependent) =>
      options.push({
        label: `${dependent.FirstName} (${dependent.RelationshipToMember})`,
        value: `${dependent.OID}`,
        memberType: 'Dependent',
      }),
    );
  } else {
    if (employeeInfo.Family) {
      options.push({
        label: `Family (${dependentsInfo.length})`,
        value: 'Family',
        memberType: 'Dependent',
      });
    }
    if (employeeInfo.OID) {
      options.push({
        label: `${employeeInfo.FirstName} ${employeeInfo.LastName}`,
        value: `${employeeInfo.OID}`,
        memberType: 'Employee',
      });
    }
    if (dependentsInfo?.length > 0) {
      dependentsInfo.map((dependent) =>
        options.push({
          label: `${dependent.FirstName} (${dependent.RelationshipToMember})`,
          value: `${dependent.OID}`,
          memberType: 'Dependent',
        }),
      );
    }
  }
  return options;
};

export const getFamilyListForAdmin = (
  employeeInfo,
  dependentsInfo,
  loggedInMemberType,
  loggedInUserOID,
) => {
  const options = [];
  if (loggedInMemberType === 'Employee') {
    if (dependentsInfo && dependentsInfo.length > 0) {
      options.push({
        label: `Family (${dependentsInfo.length + 1})`,
        value: 'Family',
      });
    }
    options.push({
      label: `${employeeInfo.FirstName} (Employee)`,
      value: employeeInfo.OID,
    });
    dependentsInfo.map((dependent) =>
      options.push({
        label: `${dependent.FirstName} (${dependent.RelationshipToMember})`,
        value: dependent.OID,
      }),
    );
  } else {
    dependentsInfo.map((dependent) => {
      if (dependent?.OID === loggedInUserOID) {
        options.push({
          label: `${dependent.FirstName} (${dependent.RelationshipToMember})`,
          value: dependent.OID,
        });
      }
    });
  }
  return options;
};

export const GetIndividualCounts = (networkInfo, countsData) => {
  const countsReturnData = {};
  if (networkInfo === 'In-network Summary') {
    countsReturnData.deductable = {
      deductableMax: countsData?.DedIndividualAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearPatient?.InNetworkDeductible,
    };
    countsReturnData.outOfPocket = {
      outOfPocketMax: countsData?.IndvOutOfPocketAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearPatient?.InNetworkOutOfPocket,
    };
  } else if (networkInfo === 'Out-of-network Summary') {
    countsReturnData.deductable = {
      deductableMax: countsData?.DedIndividualAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearPatient?.OutofAreaDeductible,
    };
    countsReturnData.outOfPocket = {
      outOfPocketMax: countsData?.IndvOutOfPocketAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearPatient?.OutofAreaOutOfPocket,
    };
  } else {
    countsReturnData.deductable = {
      deductableMax: countsData?.DedIndividualAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearPatient?.PenaltyDeductible,
    };
    countsReturnData.outOfPocket = {
      outOfPocketMax: countsData?.IndvOutOfPocketAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearPatient?.PenaltyOutOfPocket,
    };
  }
  return countsReturnData;
};

export const GetFamilyCounts = (networkInfo, countsData) => {
  const countsReturnData = {};
  if (networkInfo === 'In-network Summary') {
    countsReturnData.deductable = {
      deductableMax: countsData?.DedFamilyAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearFamily?.InNetworkDeductible,
    };
    countsReturnData.outOfPocket = {
      outOfPocketMax: countsData?.FamilyOutOfPocketAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearFamily?.InNetworkOutOfPocket,
    };
  } else if (networkInfo === 'Out-of-network Summary') {
    countsReturnData.deductable = {
      deductableMax: countsData?.DedFamilyAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearFamily?.OutofAreaDeductible,
    };
    countsReturnData.outOfPocket = {
      outOfPocketMax: countsData?.FamilyOutOfPocketAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearFamily?.OutofAreaOutOfPocket,
    };
  } else {
    countsReturnData.deductable = {
      deductableMax: countsData?.DedFamilyAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearFamily?.PenaltyDeductible,
    };
    countsReturnData.outOfPocket = {
      outOfPocketMax: countsData?.FamilyOutOfPocketAmount,
      appliedAmount:
        countsData?.SpendingAmounts?.PlanYearFamily?.PenaltyOutOfPocket,
    };
  }
  return countsReturnData;
};
export const AddSpaceBetweenKey = (key) => {
  const keySpace = key?.replace(/([A-Z])/g, ' $1');
  const finalKey = keySpace.charAt(0).toUpperCase() + keySpace.slice(1);
  return finalKey;
};

export const getNetworkByMasterId = (NetworkList) => {
  let list = [];
  let listObject = [];
  if (NetworkList && NetworkList.length > 0) {
    list = NetworkList.map((data) => {
      if (data !== undefined) {
        let requestUrl = data?.config?.url;
        let splitMasterId = requestUrl.split('MasterID/')[1];
        let masterId = splitMasterId.split('/')[0];
        console.log(masterId);
        const rows = data?.data?.Response?.Network_Tier;
        if (rows && rows.length > 0) {
          listObject.push({ masterId: masterId, data: rows });
        }
        return list;
      }
    });
  }
  return listObject;
};

export const getAccumByProduct = (accumkList) => {
  let list = [];
  let listObject = [];
  if (accumkList && accumkList.length > 0) {
    list = accumkList.map((data) => {
      const rows = data?.data?.Response;
      if (rows) {
        listObject.push({
          product: rows.BenefitAccumulators[0].Product,
          data: rows,
        });
      }
      return list;
    });
  }
  return listObject;
};

export const identifyDefaultNetwork = (
  firstItemSelected,
  networkByMasterList,
  Coverage_Network,
  showTier = false,
) => {
  let networkProps = [];
  let selectedItem = { label: 'Default', value: 0 };
  if (networkByMasterList && networkByMasterList.length > 0) {
    let filterbasedOnMaster = networkByMasterList.filter(
      (f) => f.masterId === firstItemSelected?.MasterId,
    );
    filterbasedOnMaster =
      filterbasedOnMaster && filterbasedOnMaster.length
        ? filterbasedOnMaster[0].data
        : [];

    if (filterbasedOnMaster && filterbasedOnMaster.length > 0) {
      if (showTier) {
        filterbasedOnMaster.map((data) => {
          if (
            data.NetworkTier !== undefined &&
            networkProps.findIndex(
              (idData) =>
                idData.label.toLowerCase() === data.NetworkTier.toLowerCase(),
            ) === -1
          ) {
            networkProps.push({
              label: data.NetworkTier,
              value: data?.NetworkCode ? data?.NetworkCode : 0,
              NetID: data?.NetworkCode ? data?.NetworkCode : 0,
            });
          }
        });
        networkProps.sort((a, b) => {
          return a['label'] > b['label'] ? 1 : a['label'] < b['label'] ? -1 : 0;
        });
      } else {
        filterbasedOnMaster.map((data) => {
          networkProps.push({
            label: data.NetworkDescription,
            value: data?.NetworkCode ? data?.NetworkCode : 0,
            NetID: data?.NetworkCode ? data?.NetworkCode : 0,
          });
        });
      }
    }
  }

  if (!showTier) {
    if (Coverage_Network && Coverage_Network.length > 0) {
      networkProps.unshift({
        label: Coverage_Network[0].Portal_Display_Label,
        value: 0,
      });
    }
    if (
      networkProps &&
      networkProps.length > 0 &&
      Coverage_Network &&
      Coverage_Network.length
    ) {
      networkProps = mergeArrayObjects(networkProps, Coverage_Network);
    }

    if (networkProps && networkProps.length > 0) {
      let selectedArr = networkProps.filter(
        (f) => f.value === firstItemSelected?.NetworkChoice,
      );

      if (selectedArr && selectedArr.length > 0) {
        selectedItem = selectedArr[0];
      } else {
        selectedArr = networkProps.filter((f) => f.order === 1);
        if (selectedArr && selectedArr.length > 0) {
          selectedItem = selectedArr[0];
        }
      }
    }

    const defalutSelection = networkProps.filter((data) => data.value === 0);
    if (defalutSelection.length > 1) {
      networkProps.shift();
      if (selectedItem.value === 0) {
        selectedItem = defalutSelection[1];
      }
    }
  } else {
    if (networkProps.length > 0) {
      selectedItem = networkProps[0];
    } else {
      const allOption = { label: 'ALL', value: 0 };
      networkProps.push(allOption);
      selectedItem = allOption;
    }
  }

  return {
    selected: selectedItem,
    networkProps,
  };
};

export const mergeArrayObjects = (arr1, arr2) => {
  const networkList = [];
  arr1.map((item, i) => {
    const temp = arr2.filter((f) => {
      if (
        item.label === 'Default' &&
        f.NetworkID === 'Default' &&
        f.Display_On_Portal == true
      ) {
        return f.Display_On_Portal == true;
      } else {
        return f.NetworkID === item.value && f.Display_On_Portal == true;
      }
    });
    if (temp && temp.length > 0) {
      item.label = temp[0].Portal_Display_Label;
      if (temp[0].Default) {
        item.order = 1;
      } else {
        item.order = 0;
      }
      networkList.push(item);
    }
  });
  if (networkList && networkList.length > 0) {
    const defaultSelection = networkList?.filter(
      (eachNetwork) => eachNetwork.order == 1,
    );
    if (defaultSelection?.length == 0) {
      networkList[0].order = 1;
    }
  }
  const finalNetworkList =
    networkList?.length > 0
      ? networkList
      : [
          { label: 'Default', order: 0, value: 0 },
          { label: 'Default Benefit Schedule', order: 0, value: 0, NetID: 0 },
        ];
  return finalNetworkList;
};

export const getIndplanMax = (itemSelected) => {
  return itemSelected?.IndBenefitMaximums === 'Y' ? 'Y' : 'N';
};

export const getExceptionTier = (itemSelected) => {
  return itemSelected?.SeparateDeductTier || itemSelected?.SeparateOOPTier
    ? 'Y'
    : 'N';
};

export const getBenefitYearProps = (
  Coverage_Year_Range,
  selectedBenefitYear,
) => {
  const yearsArray = Array.from(
    { length: Coverage_Year_Range },
    (_, i) => new Date().getFullYear() - i,
  );
  const yearProps = yearsArray.map((year) => {
    return { label: year, value: year };
  });

  return {
    options: yearProps,
    selectedBenefitYear: selectedBenefitYear,
  };
};

export const getNetworkDropdown = (networkByProduct) => {
  let options = [];

  //defaultList  = defaultList.filter(i => )

  if (networkByProduct.length > 0) {
    //let a = 10;
  }
  options.push({ label: 'Default Network schedule', value: '0' });
  return {
    options: options,
    selectedNetwork: { label: 'Default Network schedule', value: '0' },
  };
};

export const penaltyDetailsList = (coverdCostInfo, isFamily = true) => {
  const penaltyInformation = {
    penaltyExclusionFlag: 'NA',
    coPaymentExists: 'NA',
    coPaymentAmount: 'NA',
    coInsurancePercentage: 'NA',
    deductiableIsWaivedOff: 'NA',
    lifeTimeMaxAmount: 'NA',
    annualMaxAmount: 'NA',
    lifeTimeMaxVisits: 'NA',
    annualMaxVisits: 'NA',
    lifeTimeAccumAmount: 'NA',
    annualAccumAmount: 'NA',
    lifeTimeAccumVisits: 'NA',
    annualAccumVisits: 'NA',
    preCertification: 'NA',
  };
  if (
    Object.prototype.hasOwnProperty.call(coverdCostInfo, 'PenaltyExclusionFlag')
  ) {
    penaltyInformation.penaltyExclusionFlag =
      coverdCostInfo.PenaltyExclusionFlag;
  }
  if (
    Object.prototype.hasOwnProperty.call(coverdCostInfo, 'PenaltyCoPayment')
  ) {
    penaltyInformation.coPaymentExists = true;
    penaltyInformation.coPaymentAmount = Object.prototype.hasOwnProperty.call(
      coverdCostInfo.PenaltyCoPayment,
      'OfficeVisitPlanRules',
    )
      ? +coverdCostInfo.PenaltyCoPayment.OfficeVisitPlanRules.AmountPerVisit
      : Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyCoPayment,
          'InPatientConfinementPlanRules',
        )
      ? coverdCostInfo.PenaltyCoPayment.InPatientConfinementPlanRules
          .AmountPerDayOrConfinement
      : Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyCoPayment,
          'IndependentLaboratoryRadiologyPlanRules',
        )
      ? coverdCostInfo.PenaltyCoPayment.IndependentLaboratoryRadiologyPlanRules
          .CoPaymentAmount
      : Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyCoPayment,
          'FacilityLaboratoryRadiologyPlanRules',
        )
      ? coverdCostInfo.PenaltyCoPayment.FacilityLaboratoryRadiologyPlanRules
          .CoPaymentAmount
      : 'NA';
  } else {
    penaltyInformation.coPaymentExists = false;
  }

  if (
    Object.prototype.hasOwnProperty.call(
      coverdCostInfo,
      'PenaltyBenefitScheduleExceptions',
    )
  ) {
    penaltyInformation.deductiableIsWaivedOff =
      coverdCostInfo.PenaltyBenefitScheduleExceptions.ApplyPlanDeductible ===
      '1'
        ? false
        : true;
    if (
      Object.prototype.hasOwnProperty.call(
        coverdCostInfo.PenaltyBenefitScheduleExceptions,
        'ApplyPreCertificationPenalty',
      )
    ) {
      penaltyInformation.preCertification =
        coverdCostInfo.PenaltyBenefitScheduleExceptions.ApplyPreCertificationPenalty;
    }
    if (
      Object.prototype.hasOwnProperty.call(
        coverdCostInfo.PenaltyBenefitScheduleExceptions,
        'OverridePercentage',
      )
    ) {
      penaltyInformation.coInsurancePercentage =
        100 -
        coverdCostInfo.PenaltyBenefitScheduleExceptions.OverridePercentage;
    }

    if (isFamily) {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyBenefitScheduleExceptions,
          'PaymentLimitAmountFamilyPerLifetime',
        )
      ) {
        penaltyInformation.lifeTimeMaxAmount =
          +coverdCostInfo.PenaltyBenefitScheduleExceptions
            .PaymentLimitAmountFamilyPerLifetime;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyBenefitScheduleExceptions,
          'VisitLimitFamilyPerLifetime',
        )
      ) {
        penaltyInformation.lifeTimeMaxVisits =
          +coverdCostInfo.PenaltyBenefitScheduleExceptions
            .VisitLimitFamilyPerLifetime;
      }

      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyBenefitScheduleExceptions,
          'PaymentLimitAmountFamilyAnnualLimit',
        )
      ) {
        penaltyInformation.annualMaxAmount =
          +coverdCostInfo.PenaltyBenefitScheduleExceptions
            .PaymentLimitAmountFamilyAnnualLimit;
      }

      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyBenefitScheduleExceptions,
          'VisitLimitFamilyAnnualLimit',
        )
      ) {
        penaltyInformation.annualMaxVisits =
          +coverdCostInfo.PenaltyBenefitScheduleExceptions
            .VisitLimitFamilyAnnualLimit;
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyBenefitScheduleExceptions,
          'PaymentLimitAmountIndividualPerLifetime',
        )
      ) {
        penaltyInformation.lifeTimeMaxAmount =
          +coverdCostInfo.PenaltyBenefitScheduleExceptions
            .PaymentLimitAmountIndividualPerLifetime;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyBenefitScheduleExceptions,
          'VisitLimitIndividualPerLifetime',
        )
      ) {
        penaltyInformation.lifeTimeMaxVisits =
          +coverdCostInfo.PenaltyBenefitScheduleExceptions
            .VisitLimitIndividualPerLifetime;
      }

      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyBenefitScheduleExceptions,
          'PaymentLimitAmountIndividualAnnualLimit',
        )
      ) {
        penaltyInformation.annualMaxAmount =
          +coverdCostInfo.PenaltyBenefitScheduleExceptions
            .PaymentLimitAmountIndividualAnnualLimit;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyBenefitScheduleExceptions,
          'VisitLimitIndividualAnnualLimit',
        )
      ) {
        penaltyInformation.annualMaxVisits =
          +coverdCostInfo.PenaltyBenefitScheduleExceptions
            .VisitLimitIndividualAnnualLimit;
      }
    }
  }

  if (
    Object.prototype.hasOwnProperty.call(coverdCostInfo, 'PenaltyAnnualAccums')
  ) {
    if (isFamily) {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyAnnualAccums,
          'FamilyAmount',
        )
      ) {
        penaltyInformation.annualAccumAmount =
          +coverdCostInfo.PenaltyAnnualAccums.FamilyAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyAnnualAccums,
          'FamilyVisits',
        )
      ) {
        penaltyInformation.annualAccumVisits =
          +coverdCostInfo.PenaltyAnnualAccums.FamilyVisits;
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyAnnualAccums,
          'PatientAmount',
        )
      ) {
        penaltyInformation.annualAccumAmount =
          +coverdCostInfo.PenaltyAnnualAccums.PatientAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyAnnualAccums,
          'PatientVisits',
        )
      ) {
        penaltyInformation.annualAccumVisits =
          +coverdCostInfo.PenaltyAnnualAccums.PatientVisits;
      }
    }
  }
  if (
    Object.prototype.hasOwnProperty.call(coverdCostInfo, 'PenaltyLifeAccums')
  ) {
    if (isFamily) {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyLifeAccums,
          'FamilyAmount',
        )
      ) {
        penaltyInformation.lifeTimeAccumAmount =
          +coverdCostInfo.PenaltyLifeAccums.FamilyAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyLifeAccums,
          'FamilyVisits',
        )
      ) {
        penaltyInformation.lifeTimeAccumVisits =
          +coverdCostInfo.PenaltyLifeAccums.FamilyVisits;
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyLifeAccums,
          'PatientAmount',
        )
      ) {
        penaltyInformation.lifeTimeAccumAmount =
          +coverdCostInfo.PenaltyLifeAccums.PatientAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.PenaltyLifeAccums,
          'PatientVisits',
        )
      ) {
        penaltyInformation.lifeTimeAccumVisits =
          +coverdCostInfo.PenaltyLifeAccums.PatientVisits;
      }
    }
  }
  return penaltyInformation;
};

export const outNetworkDetailsList = (coverdCostInfo, isFamily = true) => {
  const outNetworkInformation = {
    outNetworkExclusionFlag: 'NA',
    coPaymentExists: 'NA',
    coPaymentAmount: 'NA',
    coInsurancePercentage: 'NA',
    deductiableIsWaivedOff: 'NA',
    lifeTimeMaxAmount: 'NA',
    annualMaxAmount: 'NA',
    lifeTimeMaxVisits: 'NA',
    annualMaxVisits: 'NA',
    lifeTimeAccumAmount: 'NA',
    annualAccumAmount: 'NA',
    lifeTimeAccumVisits: 'NA',
    annualAccumVisits: 'NA',
    preCertification: 'NA',
  };
  if (
    Object.prototype.hasOwnProperty.call(
      coverdCostInfo,
      'OutOfAreaExclusionFlag',
    )
  ) {
    outNetworkInformation.outNetworkExclusionFlag =
      coverdCostInfo.OutOfAreaExclusionFlag;
  }
  if (
    Object.prototype.hasOwnProperty.call(coverdCostInfo, 'OutofAreaCoPayment')
  ) {
    outNetworkInformation.coPaymentExists = true;
    outNetworkInformation.coPaymentAmount =
      Object.prototype.hasOwnProperty.call(
        coverdCostInfo.OutofAreaCoPayment,
        'OfficeVisitPlanRules',
      )
        ? +coverdCostInfo.OutofAreaCoPayment.OfficeVisitPlanRules.AmountPerVisit
        : Object.prototype.hasOwnProperty.call(
            coverdCostInfo.OutofAreaCoPayment,
            'InPatientConfinementPlanRules',
          )
        ? coverdCostInfo.OutofAreaCoPayment.InPatientConfinementPlanRules
            .AmountPerDayOrConfinement
        : Object.prototype.hasOwnProperty.call(
            coverdCostInfo.OutofAreaCoPayment,
            'IndependentLaboratoryRadiologyPlanRules',
          )
        ? coverdCostInfo.OutofAreaCoPayment
            .IndependentLaboratoryRadiologyPlanRules.CoPaymentAmount
        : Object.prototype.hasOwnProperty.call(
            coverdCostInfo.OutofAreaCoPayment,
            'FacilityLaboratoryRadiologyPlanRules',
          )
        ? coverdCostInfo.OutofAreaCoPayment.FacilityLaboratoryRadiologyPlanRules
            .CoPaymentAmount
        : 'NA';
  } else {
    outNetworkInformation.coPaymentExists = false;
  }

  if (
    Object.prototype.hasOwnProperty.call(
      coverdCostInfo,
      'OutOfAreaBenefitScheduleExceptions',
    )
  ) {
    outNetworkInformation.deductiableIsWaivedOff =
      coverdCostInfo.OutOfAreaBenefitScheduleExceptions.ApplyPlanDeductible ===
      '1'
        ? false
        : true;
    if (
      Object.prototype.hasOwnProperty.call(
        coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
        'ApplyPreCertificationPenalty',
      )
    ) {
      outNetworkInformation.preCertification =
        coverdCostInfo.OutOfAreaBenefitScheduleExceptions.ApplyPreCertificationPenalty;
    }
    if (
      Object.prototype.hasOwnProperty.call(
        coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
        'OverridePercentage',
      )
    ) {
      outNetworkInformation.coInsurancePercentage =
        100 -
        coverdCostInfo.OutOfAreaBenefitScheduleExceptions.OverridePercentage;
    }

    if (isFamily) {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
          'PaymentLimitAmountFamilyPerLifetime',
        )
      ) {
        outNetworkInformation.lifeTimeMaxAmount =
          +coverdCostInfo.OutOfAreaBenefitScheduleExceptions
            .PaymentLimitAmountFamilyPerLifetime;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
          'VisitLimitFamilyPerLifetime',
        )
      ) {
        outNetworkInformation.lifeTimeMaxVisits =
          +coverdCostInfo.OutOfAreaBenefitScheduleExceptions
            .VisitLimitFamilyPerLifetime;
      }

      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
          'PaymentLimitAmountFamilyAnnualLimit',
        )
      ) {
        outNetworkInformation.annualMaxAmount =
          +coverdCostInfo.OutOfAreaBenefitScheduleExceptions
            .PaymentLimitAmountFamilyAnnualLimit;
      }

      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
          'VisitLimitFamilyAnnualLimit',
        )
      ) {
        outNetworkInformation.annualMaxVisits =
          +coverdCostInfo.OutOfAreaBenefitScheduleExceptions
            .VisitLimitFamilyAnnualLimit;
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
          'PaymentLimitAmountIndividualPerLifetime',
        )
      ) {
        outNetworkInformation.lifeTimeMaxAmount =
          +coverdCostInfo.OutOfAreaBenefitScheduleExceptions
            .PaymentLimitAmountIndividualPerLifetime;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
          'VisitLimitIndividualPerLifetime',
        )
      ) {
        outNetworkInformation.lifeTimeMaxVisits =
          +coverdCostInfo.OutOfAreaBenefitScheduleExceptions
            .VisitLimitIndividualPerLifetime;
      }

      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
          'PaymentLimitAmountIndividualAnnualLimit',
        )
      ) {
        outNetworkInformation.annualMaxAmount =
          +coverdCostInfo.OutOfAreaBenefitScheduleExceptions
            .PaymentLimitAmountIndividualAnnualLimit;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaBenefitScheduleExceptions,
          'VisitLimitIndividualAnnualLimit',
        )
      ) {
        outNetworkInformation.annualMaxVisits =
          +coverdCostInfo.OutOfAreaBenefitScheduleExceptions
            .VisitLimitIndividualAnnualLimit;
      }
    }
  }

  if (
    Object.prototype.hasOwnProperty.call(
      coverdCostInfo,
      'OutOfAreaAnnualAccums',
    )
  ) {
    if (isFamily) {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaAnnualAccums,
          'FamilyAmount',
        )
      ) {
        outNetworkInformation.annualAccumAmount =
          +coverdCostInfo.OutOfAreaAnnualAccums.FamilyAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaAnnualAccums,
          'FamilyVisits',
        )
      ) {
        outNetworkInformation.annualAccumVisits =
          +coverdCostInfo.OutOfAreaAnnualAccums.FamilyVisits;
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaAnnualAccums,
          'PatientAmount',
        )
      ) {
        outNetworkInformation.annualAccumAmount =
          +coverdCostInfo.OutOfAreaAnnualAccums.PatientAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaAnnualAccums,
          'PatientVisits',
        )
      ) {
        outNetworkInformation.annualAccumVisits =
          +coverdCostInfo.OutOfAreaAnnualAccums.PatientVisits;
      }
    }
  }
  if (
    Object.prototype.hasOwnProperty.call(coverdCostInfo, 'OutOfAreaLifeAccums')
  ) {
    if (isFamily) {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaLifeAccums,
          'FamilyAmount',
        )
      ) {
        outNetworkInformation.lifeTimeAccumAmount =
          +coverdCostInfo.OutOfAreaLifeAccums.FamilyAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaLifeAccums,
          'FamilyVisits',
        )
      ) {
        outNetworkInformation.lifeTimeAccumVisits =
          +coverdCostInfo.OutOfAreaLifeAccums.FamilyVisits;
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaLifeAccums,
          'PatientAmount',
        )
      ) {
        outNetworkInformation.lifeTimeAccumAmount =
          +coverdCostInfo.OutOfAreaLifeAccums.PatientAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.OutOfAreaLifeAccums,
          'PatientVisits',
        )
      ) {
        outNetworkInformation.lifeTimeAccumVisits =
          +coverdCostInfo.OutOfAreaLifeAccums.PatientVisits;
      }
    }
  }
  return outNetworkInformation;
};

export const inNetworkDetailsList = (coverdCostInfo, isFamily = true) => {
  const inNetworkInformation = {
    inNetworkExclusionFlag: 'NA',
    coPaymentExists: 'NA',
    coPaymentAmount: 'NA',
    coInsurancePercentage: 'NA',
    deductiableIsWaivedOff: 'NA',
    lifeTimeMaxAmount: 'NA',
    annualMaxAmount: 'NA',
    lifeTimeMaxVisits: 'NA',
    annualMaxVisits: 'NA',
    lifeTimeAccumAmount: 'NA',
    annualAccumAmount: 'NA',
    lifeTimeAccumVisits: 'NA',
    annualAccumVisits: 'NA',
    preCertification: 'NA',
  };
  if (
    Object.prototype.hasOwnProperty.call(
      coverdCostInfo,
      'InNetworkExclusionFlag',
    )
  ) {
    inNetworkInformation.inNetworkExclusionFlag =
      coverdCostInfo.InNetworkExclusionFlag;
  }
  if (
    Object.prototype.hasOwnProperty.call(coverdCostInfo, 'InNetworkCoPayment')
  ) {
    inNetworkInformation.coPaymentExists = true;
    inNetworkInformation.coPaymentAmount = Object.prototype.hasOwnProperty.call(
      coverdCostInfo.InNetworkCoPayment,
      'OfficeVisitPlanRules',
    )
      ? +coverdCostInfo.InNetworkCoPayment.OfficeVisitPlanRules.AmountPerVisit
      : Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkCoPayment,
          'InPatientConfinementPlanRules',
        )
      ? coverdCostInfo.InNetworkCoPayment.InPatientConfinementPlanRules
          .AmountPerDayOrConfinement
      : Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkCoPayment,
          'IndependentLaboratoryRadiologyPlanRules',
        )
      ? coverdCostInfo.InNetworkCoPayment
          .IndependentLaboratoryRadiologyPlanRules.CoPaymentAmount
      : Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkCoPayment,
          'FacilityLaboratoryRadiologyPlanRules',
        )
      ? coverdCostInfo.InNetworkCoPayment.FacilityLaboratoryRadiologyPlanRules
          .CoPaymentAmount
      : 'NA';
  } else {
    inNetworkInformation.coPaymentExists = false;
  }

  if (
    Object.prototype.hasOwnProperty.call(
      coverdCostInfo,
      'InNetworkBenefitScheduleExceptions',
    )
  ) {
    inNetworkInformation.deductiableIsWaivedOff =
      coverdCostInfo.InNetworkBenefitScheduleExceptions.ApplyPlanDeductible ===
      '1'
        ? false
        : true;
    if (
      Object.prototype.hasOwnProperty.call(
        coverdCostInfo.InNetworkBenefitScheduleExceptions,
        'ApplyPreCertificationPenalty',
      )
    ) {
      inNetworkInformation.preCertification =
        coverdCostInfo.InNetworkBenefitScheduleExceptions.ApplyPreCertificationPenalty;
    }
    if (
      Object.prototype.hasOwnProperty.call(
        coverdCostInfo.InNetworkBenefitScheduleExceptions,
        'OverridePercentage',
      )
    ) {
      inNetworkInformation.coInsurancePercentage =
        100 -
        coverdCostInfo.InNetworkBenefitScheduleExceptions.OverridePercentage;
    }

    if (isFamily) {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkBenefitScheduleExceptions,
          'PaymentLimitAmountFamilyPerLifetime',
        )
      ) {
        inNetworkInformation.lifeTimeMaxAmount =
          +coverdCostInfo.InNetworkBenefitScheduleExceptions
            .PaymentLimitAmountFamilyPerLifetime;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkBenefitScheduleExceptions,
          'VisitLimitFamilyPerLifetime',
        )
      ) {
        inNetworkInformation.lifeTimeMaxVisits =
          +coverdCostInfo.InNetworkBenefitScheduleExceptions
            .VisitLimitFamilyPerLifetime;
      }

      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkBenefitScheduleExceptions,
          'PaymentLimitAmountFamilyAnnualLimit',
        )
      ) {
        inNetworkInformation.annualMaxAmount =
          +coverdCostInfo.InNetworkBenefitScheduleExceptions
            .PaymentLimitAmountFamilyAnnualLimit;
      }

      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkBenefitScheduleExceptions,
          'VisitLimitFamilyAnnualLimit',
        )
      ) {
        inNetworkInformation.annualMaxVisits =
          +coverdCostInfo.InNetworkBenefitScheduleExceptions
            .VisitLimitFamilyAnnualLimit;
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkBenefitScheduleExceptions,
          'PaymentLimitAmountIndividualPerLifetime',
        )
      ) {
        inNetworkInformation.lifeTimeMaxAmount =
          +coverdCostInfo.InNetworkBenefitScheduleExceptions
            .PaymentLimitAmountIndividualPerLifetime;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkBenefitScheduleExceptions,
          'VisitLimitIndividualPerLifetime',
        )
      ) {
        inNetworkInformation.lifeTimeMaxVisits =
          +coverdCostInfo.InNetworkBenefitScheduleExceptions
            .VisitLimitIndividualPerLifetime;
      }

      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkBenefitScheduleExceptions,
          'PaymentLimitAmountIndividualAnnualLimit',
        )
      ) {
        inNetworkInformation.annualMaxAmount =
          +coverdCostInfo.InNetworkBenefitScheduleExceptions
            .PaymentLimitAmountIndividualAnnualLimit;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkBenefitScheduleExceptions,
          'VisitLimitIndividualAnnualLimit',
        )
      ) {
        inNetworkInformation.annualMaxVisits =
          +coverdCostInfo.InNetworkBenefitScheduleExceptions
            .VisitLimitIndividualAnnualLimit;
      }
    }
  }

  if (
    Object.prototype.hasOwnProperty.call(
      coverdCostInfo,
      'InNetworkAnnualAccums',
    )
  ) {
    if (isFamily) {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkAnnualAccums,
          'FamilyAmount',
        )
      ) {
        inNetworkInformation.annualAccumAmount =
          +coverdCostInfo.InNetworkAnnualAccums.FamilyAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkAnnualAccums,
          'FamilyVisits',
        )
      ) {
        inNetworkInformation.annualAccumVisits =
          +coverdCostInfo.InNetworkAnnualAccums.FamilyVisits;
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkAnnualAccums,
          'PatientAmount',
        )
      ) {
        inNetworkInformation.annualAccumAmount =
          +coverdCostInfo.InNetworkAnnualAccums.PatientAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkAnnualAccums,
          'PatientVisits',
        )
      ) {
        inNetworkInformation.annualAccumVisits =
          +coverdCostInfo.InNetworkAnnualAccums.PatientVisits;
      }
    }
  }
  if (
    Object.prototype.hasOwnProperty.call(coverdCostInfo, 'InNetworkLifeAccums')
  ) {
    if (isFamily) {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkLifeAccums,
          'FamilyAmount',
        )
      ) {
        inNetworkInformation.lifeTimeAccumAmount =
          +coverdCostInfo.InNetworkLifeAccums.FamilyAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkLifeAccums,
          'FamilyVisits',
        )
      ) {
        inNetworkInformation.lifeTimeAccumVisits =
          +coverdCostInfo.InNetworkLifeAccums.FamilyVisits;
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkLifeAccums,
          'PatientAmount',
        )
      ) {
        inNetworkInformation.lifeTimeAccumAmount =
          +coverdCostInfo.InNetworkLifeAccums.PatientAmount;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          coverdCostInfo.InNetworkLifeAccums,
          'PatientVisits',
        )
      ) {
        inNetworkInformation.lifeTimeAccumVisits =
          +coverdCostInfo.InNetworkLifeAccums.PatientVisits;
      }
    }
  }
  return inNetworkInformation;
};

export const getFormattedConfiguredNetworkOption = ({
  networkData = [],
  forNetworkTierDropdownData = {},
  networkListWithMasterId = [],
  Coverage_Network = [],
  Display_Network_For_Coverage_Member = true,
  Value_Network_For_Coverage_Member = 'network',
}) => {
  const configurationNetworkData = Coverage_Network?.map((item) => {
    if (item?.NetworkName && item?.NetworkID && item?.Display_On_Portal)
      return {
        label: item?.Portal_Display_Label || item?.NetworkName,
        value: item?.NetworkID,
        displayOnPortal: item?.Display_On_Portal,
      };
  });
  if (Display_Network_For_Coverage_Member === true) {
    if (networkData && Value_Network_For_Coverage_Member === 'network') {
      const networksData = [...networkData];
      const filterByNetworkConfiguration = configurationNetworkData?.filter(
        (configItem) =>
          networksData.some(
            (networkItem) => networkItem?.NetworkID === configItem?.value,
          ) || configItem?.value === 'Default',
      );
      return filterByNetworkConfiguration;
    } else if (networkData && Value_Network_For_Coverage_Member === 'tier') {
      const networkTierData = identifyDefaultNetwork(
        {
          ...forNetworkTierDropdownData,
          MasterId: String(
            forNetworkTierDropdownData?.MasterId
              ? forNetworkTierDropdownData?.MasterId
              : forNetworkTierDropdownData?.MasterID,
          ),
        },
        networkListWithMasterId,
        Coverage_Network,
        true,
      );
      console.log('debug_tier', networkTierData);
      return networkTierData?.networkProps?.length > 0
        ? networkTierData?.networkProps?.filter((item) => item?.label !== 'ALL')
        : [];
    }
  }
  return configurationNetworkData?.filter((item) => item?.value === 'Default');
};
